import { Card, Col, Row } from "react-bootstrap";
import { IMeetingDetails } from "../../../api/IMeeting";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { ComplaintIcon } from "../../../leap-components/icons/LeapIcons";

interface MeetingHeaderProps {
  meetingDetails: IMeetingDetails;
  licenceProfile: ILicenceProfile;
}

const MeetingHeader = ({
  meetingDetails,
  licenceProfile,
}: MeetingHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <ComplaintIcon />
                  </td>
                  <td>
                    <h2>Meeting: {meetingDetails.reference}</h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Reference No."}
              value={meetingDetails.reference}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows label={"Status"} value={meetingDetails.status} />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Authorisation Version"}
              value={meetingDetails.licence_regno}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default MeetingHeader;
